
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { namespace } from "vuex-class";
const service = namespace("service");
const setting = namespace("setting");
@Component({})
export default class DelegatePrint extends Vue {
  @service.Action getPrintStoreLogo;
  @setting.Action queryPrintFieldListByCategory;
  @Prop({ default: () => {} })
  orderData: any;
  @Prop({ default: undefined })
  receiveFieldList: any;
  dayjs = dayjs;
  printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;

  get $orderData() {
    return this.orderData;
  }
  created() {
    this.getLogoImg();
    this.getTemplateField();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo;
    });
  }
  fieldList: any = [];
  get availableFieldArr() {
    if (this.receiveFieldList) {
      return this.receiveFieldList.filter(item => item.status === 1).map(item => item.fieldCode);
    }
    return this.fieldList.filter(item => item.status === 1).map(item => item.fieldCode);
  }
  getTemplateField() {
    this.queryPrintFieldListByCategory({ category: "PRINT_DELEGATION_CREDENTIALS" }).then(data => {
      this.fieldList = this.$safeValue(data, "data.printFieldList");
    });
  }
}
